import React from "react";
import { Reveal } from "@/components/anim";
import { LIFECYCLE, KEY_FUNCTIONS } from "@/data/content";

export default function PlatformLifecycle() {
  return (
    <section data-testid="lifecycle-section" className="bg-bg-dark py-28 md:py-40">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal>
          <p className="text-brand-teal text-xs font-bold uppercase tracking-[0.25em] mb-4">Full-Lifecycle Platform</p>
          <h2 className="font-heading text-4xl md:text-6xl font-medium tracking-tight text-white leading-none max-w-3xl">
            Developer. Owner. Operator.
          </h2>
        </Reveal>

        {/* Lifecycle timeline */}
        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 border border-white/10">
          {LIFECYCLE.map((s, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <div className="relative h-full p-7 border-b lg:border-b-0 lg:border-r border-white/10 last:border-r-0 group hover:bg-brand-navy transition-colors duration-300">
                <span className="font-accent italic text-brand-teal text-3xl">0{i + 1}</span>
                <h3 className="mt-4 font-heading text-white text-lg md:text-xl leading-tight">{s.phase}</h3>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Facility image */}
        <Reveal delay={0.05}>
          <div className="mt-16 relative overflow-hidden border border-white/10">
            <img
              src="/assets/desal-plant.jpg"
              alt="Coastal seawater reverse-osmosis desalination facility"
              className="w-full h-[280px] md:h-[460px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-bg-dark/80 via-transparent to-transparent" />
            <div className="absolute bottom-0 left-0 p-6 md:p-10">
              <p className="text-white/90 font-heading text-xl md:text-2xl max-w-2xl leading-tight">
                Modern coastal seawater reverse-osmosis facilities — engineered for scale, reliability, and
                sustainability.
              </p>
            </div>
          </div>
        </Reveal>

        {/* Key functions */}
        <div className="mt-24 md:mt-32">
          <Reveal>
            <p className="text-brand-teal text-xs font-bold uppercase tracking-[0.25em] mb-3">Our Key Functions</p>
            <h3 className="font-heading text-3xl md:text-5xl font-medium tracking-tight text-white leading-none max-w-3xl mb-12">
              What US Desalination does.
            </h3>
          </Reveal>
          <div className="border-t border-white/10">
            {KEY_FUNCTIONS.map((f, i) => (
              <Reveal key={i} delay={i * 0.05}>
                <div className="group grid grid-cols-1 md:grid-cols-12 gap-3 md:gap-10 items-start border-b border-white/10 py-8 md:py-10 hover:bg-brand-navy/40 transition-colors duration-300">
                  <div className="md:col-span-1">
                    <span className="font-accent italic text-brand-teal text-3xl md:text-4xl">0{i + 1}</span>
                  </div>
                  <div className="md:col-span-4">
                    <h4 className="font-heading text-white text-2xl md:text-3xl tracking-tight leading-tight transition-transform duration-300 group-hover:translate-x-2">
                      {f.title}
                    </h4>
                  </div>
                  <div className="md:col-span-7">
                    <p className="text-white/60 text-base md:text-lg leading-relaxed">{f.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
